import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faTimes, faHome } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  faArrowLeft, 
  faTag, 
  faImages,
  faCheck,
  
} from '@fortawesome/free-solid-svg-icons';

const QuotationDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { quotationId } = location.state || {};
  console.log('Quotation ID:', quotationId);

  const [quotationData, setQuotationData] = useState(null);
  const [isDetailsModalVisible, setIsDetailsModalVisible] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState(null);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [attributes, setAttributes] = useState([]);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isProductModalVisible, setIsProductModalVisible] = useState(false);
const [showNoChangesModal, setShowNoChangesModal] = useState(false);
const fetchUrl = process.env.REACT_APP_FORE_APILINK;

  const fetchUrl2 = process.env.REACT_APP_FORE_BRICKBUCKET;
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
  const [categories, setCategories] = useState(null);
  const [isSavingQuote, setIsSavingQuote] = useState(false);
const [isDesignsModalVisible, setIsDesignsModalVisible] = useState(false);
const [showDesignConfirmation, setShowDesignConfirmation] = useState(false);
const [selectedImageUrl, setSelectedImageUrl] = useState(null);
const [selectedDesign, setSelectedDesign] = useState(null);
const [selectedProduct, setSelectedProduct] = useState(null);
const [quotationType, setQuotationType] = useState('');

useEffect(() => {
    fetchQuotationDetails();
  }, []);

  useEffect(() => {
    if (quotationData) {
      setQuotationType(quotationData.quotation_type);
    }
  }, [quotationData])

  const fetchQuotationDetails = async () => {
    try {
      const token = await sessionStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-quotation?quotation_id=${quotationId}`, {
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });

      console.log(response);
      const data = await response.json();
      setQuotationData(data.data);
      console.log(data.data);
    } catch (error) {
      console.error('Error fetching quotation:', error);
    }
  };

  useEffect(() => {
    if (quotationData) {
      fetchAttributesByproductCategory();
    }
  }, [quotationData]);

  const fetchAttributesByproductCategory = async ()=>{
    try {
      const token = await sessionStorage.getItem('token');
      const ProductCategoryId = quotationData.product_category_id._id;
      const response = await fetch(`${fetchUrl2}product-attributes/get-all-attributes-by-productCategory?product_category_id=${ProductCategoryId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      const data = await response.json();
      //console.log(data);
      if (data.success) {
        setAttributes(data.data);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
    }
    };

    const handleChangeProduct = async (categoryName, currentProductId) => {
      setSelectedCategory(categoryName);
      setSelectedProductId(currentProductId);
      setSelectedDesign(null);
      setIsProductModalVisible(true);
      
      try {
        const token = await sessionStorage.getItem('token');
        const organizationId = await sessionStorage.getItem('organizationId');
        const ProductCategoryId = quotationData.product_category_id._id;
        
    
        // Log the API URL being called
        const apiUrl = fetchUrl2 + `product-groups/get-productGroups-by-productCategory?product_category_id=${ProductCategoryId}&organizationId=${organizationId}`
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
    
        if (!response.ok) {
          console.error('Product groups API error:', response.status, response.statusText);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const data = await response.json();
        
        if (data && data.success) {
          setAvailableProducts(data.data);
        }
      } catch (error) {
        console.error('Error fetching product groups:', error);
      }
    };
  
  
  const handleViewDesigns = async (item) => {
    const designId = item.selected_design?.design_id || null;
    setSelectedCategory(item?.area_types?.area_name);
    setSelectedDesign(designId);
    
    try {
      const token = await sessionStorage.getItem('token');
      const url = `${process.env.REACT_APP_FORE_BRICKBUCKET}product/get-products-by-product-group?product_group_id=${item.item_id}`; 
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      
      if (!response.ok) {
        console.error('API response not OK:', response.status, response.statusText);
        return;
      }
      
      const data = await response.json();
      console.log('API Response:', data);
      
      if (data.success) {
        const designs = data.data.map(product => ({
          _id: product.item_id,
          product_name: product.item_name,
          product_image: product.item_image,
          selected: product.item_id === designId
        }));
        
        console.log('Fetched designs:', designs);
        
        setSelectedProduct({
          ...item,
          products: designs
        });
        
        setIsDesignsModalVisible(true);
      }
    } catch (error) {
      console.error('Error preparing designs view:', error);
    }
  };

  const handleDesignSelection = async (product) => {
    console.log('Selecting design:', product);
  
    const parentItem = quotationData?.items?.find(
      (item) => item?.area_types?.area_name === selectedCategory
    );
  
    if (quotationData?._id && parentItem) {
      try {
        const result = await updateSelectedBaseProduct(
          quotationData._id,
          selectedCategory,  
          parentItem.item_id,
          product._id        
        );
        console.log('Update result:', result);
  
        if (result) {
          const updatedQuotationData = { ...quotationData };
          const itemIndex = updatedQuotationData.items.findIndex(
            (item) => item?.area_types?.area_name === selectedCategory
          );
  
          if (itemIndex !== -1) {
            updatedQuotationData.items[itemIndex].selected_design = {
              design_name: product.product_name,
              design_id: product._id,
              design_image: product.product_image,
              vendor_id: parentItem.vendor_id || null,
              vendor_name: parentItem.vendor_name || null,
              design_price: parentItem.selling_price,
              design_cost_price: parentItem.cost_price || 0,
            };
  
            updatedQuotationData.items[itemIndex].isModified = true;
  
            setQuotationData(updatedQuotationData);
            setSelectedDesign(product._id);
            setHasUnsavedChanges(true);
            setIsDesignsModalVisible(false);
            setShowDesignConfirmation(true);
  
            setTimeout(() => {
              setShowDesignConfirmation(false);
            }, 2000);
          }
        } else {
          alert('Failed to update design. Please try again.');
        }
      } catch (error) {
        console.error('Error updating selected design:', error);
        alert('An error occurred while updating the design.');
      }
    }
  };
const updateSelectedBaseProduct = async (quotationId, areaName, itemId, subItemId) => {
  try {
    const token = sessionStorage.getItem('token');
    const url = `${fetchUrl}/summary/update-selected-product`;
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify({
        quotationId,
        area_name: areaName,
        item_id: itemId,
        sub_item_id: subItemId
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API response error:', response.status, response.statusText, errorText);
      return false; // Return false to indicate API call failure
    }

    const data = await response.json();
    console.log('API Response:', data);

    return data.success ? true : false;
  } catch (error) {
    console.error('API Call Error:', error.message);
    return false; // Return false to indicate API call failure
  }
};

const handleProductSelection = (selectedProduct) => {
  const sqFtPerBoxAttribute = attributes.find(attr => attr.attribute_name === "Sq Ft per Box");
  console.log('Sq Ft per Box Attribute:', sqFtPerBoxAttribute);
  
  const selectedSqFtValue = sqFtPerBoxAttribute?.attribute_values.find(
    val => selectedProduct.attribute_value_ids?.includes(val.attribute_value_id)
  );
  
  const sqFtPerBox = selectedSqFtValue ? parseFloat(selectedSqFtValue.attribute_value) : 1;
  console.log('Sq Ft per Box:', sqFtPerBox);
  
  // Find the item to update
  const itemToUpdate = quotationData.items.find(item => 
    quotationData.quotation_type === 'Group' 
      ? item?.area_types?.area_name === selectedCategory
      : item.item_id === selectedProductId
  );
  
  if (itemToUpdate) {
    console.log('=== ITEM BEFORE UPDATE ===');
    console.log('Item to update:', itemToUpdate);
    console.log('Item ID before update:', itemToUpdate.item_id);
    console.log('Item Name before update:', itemToUpdate.item_name);
    console.log('Area:', itemToUpdate?.area_types?.area);
  }
  
  // Update the items array with the new product group
  const updatedItems = quotationData.items.map(item => {
    if ((quotationData.quotation_type === 'Group' && item?.area_types?.area_name === selectedCategory) ||
        (quotationData.quotation_type === 'General' && item.item_id === selectedProductId)) {
      
      // Calculate quantities based on quotation type
      let totalBoxes = item.quantity;
      let area = 0;
      
      if (quotationData.quotation_type === 'Group') {
        area = parseFloat(item?.area_types?.area);
        totalBoxes = Math.ceil(area / sqFtPerBox);
      }
      
      // Calculate new total price based on updated quantity and selected product's price
      const newTotal = totalBoxes * selectedProduct.selling_price;
      
      // Calculate new tax amount
      const newTaxAmount = (newTotal * (selectedProduct.GST / 100));

      const updatedItem = {
        ...item,
        item_id: selectedProduct._id, // This is the product group ID
        item_name: selectedProduct.product_group_name,
        price_per_sqft: selectedProduct.price_per_sqft,
        quantity: totalBoxes,
        selling_price: selectedProduct.selling_price,
        total: newTotal,
        tax_rate: selectedProduct.GST || 0,
        tax_amount: newTaxAmount,
        total_tax_amount: newTaxAmount,
        isModified: true,
        selected_design: null // Reset selected design when changing product group
      };
      
      
      
      return updatedItem;
    }
    return item;
  });

  // Update quotation data with new totals
  const newSubtotal = updatedItems.reduce((sum, item) => sum + item.total, 0);
  const newTotalTax = updatedItems.reduce((sum, item) => sum + item.total_tax_amount, 0);
  const newTotal = newSubtotal + newTotalTax;
  
  
  const updatedQuotationData = {
    ...quotationData,
    items: updatedItems,
    subtotal: newSubtotal,
    tax_amount: newTotalTax,
    total: newTotal
  };
  
  
  
  setQuotationData(updatedQuotationData);
  setSelectedDesign(null);
  setHasUnsavedChanges(true);
  setIsProductModalVisible(false);
};


  const handleSaveQuotation = async () => {
    setIsSavingQuote(true);

    try {
      const token = await sessionStorage.getItem('token');
      const organizationId = await sessionStorage.getItem('organizationId');
  
      const hasModifiedProducts = quotationData?.items?.some(item => item.isModified);
  
      if (!hasModifiedProducts) {
        setShowNoChangesModal(true);
        return;
      }
    
      

      // Create new quotation payload without quotation_number
      const { _id, quotation_number, quotation_date, ...quotationWithoutNumber } = quotationData;
  
      const quotationPayload = {
        ...quotationWithoutNumber,
        quotation_date: new Date().toISOString(),
        organizationId,
        selected: false,
        items: quotationData.items.map(item => ({
          item_id: item.item_id,
          item_name: item.item_name,
          price_per_sqft: item.price_per_sqft,
          quantity: item.quantity,
          selling_price: item.selling_price,
          cost_price: item.cost_price || 0,
          discount: item.discount || 0,
          tax_rate: item.tax_rate,
          tax_type: item.tax_type || 'GST', 
          total_tax_amount: item.total_tax_amount,
          tax_amount: item.tax_amount,
          total: item.total,
          UOM: item.UOM,
          UOM_id: item.UOM_id,
          area_types: item?.area_types,
          quantity_breakup: item.quantity_breakup

        }))
      };
     console.log('Quotation Payload:', quotationPayload);
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/save-quotation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify(quotationPayload),
      });
  
      const data = await response.json();
      console.log('Quotation saved:', data);
      if (data.success) {
        navigateToQuoteSummary(data.data)
        //navigate('/consumer/app/home');
      }
    } catch (error) {
      console.error('Failed to save quotation:', error);
    }
  };
   const navigateToQuoteSummary = (quotation) => {
    try {
      const navigationData = {
        quotation_id: quotation._id || '',
        product_category_id: quotation.product_category_id || '',
        project_id: quotation.project_id || '',
        package_id: '',
        product_category_name : 'Tiles',
        projectName:  '',
        timestamp: Date.now()
      };

      navigate('/consumer/app/summarydetails', {
        state: navigationData,
        replace: true 
      });
 
    } catch (error) {
      console.error('Navigation failed:', error);
      // Fallback navigation
      navigate('/consumer/app/summarydetails');
    }
  }; 
  
 

const ProductDesignsModal = ({
  products,
  onClose,
  handleProductSelection,
  selectedDesign,
  setSelectedDesign,
  setSelectedImageUrl,
  imageUrl,
  selectedCategory,
  currentSelectedProduct,
  categories
}) => {
  // Map the products to include the selected status based on the quotation data
  const mappedProducts = products.map(product => {
    // Check if this product is the selected design
    const isSelected = product._id === selectedDesign;
    return {
      ...product,
      selected: isSelected
    };
  });

  return (
    <div className="fixed inset-0 flex items-end justify-center z-50">
      <div className="bg-black/10 backdrop-blur-xs absolute inset-0 transition-opacity" onClick={onClose} />
      <div className="bg-white rounded-t-2xl w-full max-w-2xl fixed bottom-0 z-10 animate-slide-up">
        <div className="p-4 border-b border-gray-100">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-bold text-gray-800">Available Designs</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
              <FontAwesomeIcon icon={faTimes} className="text-gray-500" />
            </button>
          </div>
        </div>

        <div className="p-4 max-h-[70vh] overflow-y-auto">
          {(!mappedProducts?.some(product => product.product_image)) ? (
            <div className="flex flex-col items-center justify-center py-12">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                <FontAwesomeIcon icon={faImages} className="text-gray-400 text-xl" />
              </div>
              <h4 className="text-gray-500 font-medium">No product images available</h4>
            </div>
          ) : (
            <div className="grid grid-cols-2 gap-4">
              {mappedProducts.map((product) => (
                product.product_image && (
                  <div key={product._id} className="group bg-white rounded-xl border border-gray-100 overflow-hidden hover:shadow-md transition-all duration-300">
                    <div
                      className="relative aspect-square cursor-pointer"
                      onClick={() => {
                        setSelectedImageUrl(`${imageUrl}${product.product_image}`);
                        onClose();
                      }}
                    >
                      <img
                        src={`${imageUrl}${product.product_image}`}
                        alt={product.product_name}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                    </div>
                    
                    <div className="p-3 flex items-center gap-2 cursor-pointer hover:bg-red-50 transition-all duration-300">
                      <div className="flex items-center gap-2" onClick={async (e) => {
                        e.stopPropagation();
                        const result = await handleProductSelection({
                          ...product,
                          room_category: selectedCategory
                        });
                      }}
                      >
                        <div className="relative">
                          <input
                            type="radio"
                            name="design"
                            value={product._id}
                            checked={product.selected}
                            onChange={() => {}}
                            className="appearance-none w-5 h-5 rounded-full border-2 border-gray-300 checked:border-[#EA011F] transition-colors cursor-pointer 
                            checked:before:content-[''] checked:before:absolute checked:before:w-2.5 checked:before:h-2.5 checked:before:bg-[#EA011F] checked:before:rounded-full 
                            checked:before:top-1/2 checked:before:left-1/2 checked:before:-translate-x-1/2 checked:before:-translate-y-1/2 relative"
                          />
                        </div>
                        <h4 className="text-[10px] font-semibold text-gray-800 group-hover:text-[#EA011F] transition-colors">
                          {product.product_name}
                        </h4>
                      </div>
                    </div>
                  </div>
                )
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};


  const renderHeader = () => (
    <div className="bg-white p-5 shadow-md sticky top-0 z-50">
      <div className="flex items-center justify-between mb-2 relative">
        <button onClick={() => navigate(-1)} className="absolute left-0">
          <FontAwesomeIcon icon={faArrowLeft} className="text-[#736f70] text-2xl" />
        </button>
        <div className="flex-1 text-center">
          <h1 className="text-xl font-bold text-[#EA011F]">{quotationData?.quotation_number}</h1>
        </div> 
        <button onClick={() => navigate('/consumer/app/home')} className="absolute right-0">
  <FontAwesomeIcon icon={faHome} className="text-[#736f70] text-xl hover:text-red-500 transition-colors duration-200" />
</button>
      </div>
      <div className="flex items-center justify-between bg-red-50 p-2 rounded-sm">
        <div className="flex items-center">
          <FontAwesomeIcon icon={faTag} className="text-[#EA011F] mr-2" />
          <span className="text-md font-semibold text-gray-700">Quotation Details</span>
          </div>
          <div className="justify-right items-right">
  <span className="text-md text-[#EA011F] font-bold">
    ₹{Number(quotationData?.total?.toFixed(0)).toLocaleString('en-IN')}
  </span>
  <div className="justify-right items-right">
  <span className="text-[10px] text-gray-500 font-bold  block -mt-1">GST inclusive</span>
  </div>
</div>
        
      </div>
    </div>
  );
  
  const groupItemsById = (items) => {
    const groupedItems = {};
  
    items.forEach((item) => {
      if (groupedItems[item.item_id]) {
        // If the item already exists, add its quantity and total
        groupedItems[item.item_id].quantity += item.quantity;
        groupedItems[item.item_id].total += item.total;
      } else {
        // Otherwise, add the item to the grouped list
        groupedItems[item.item_id] = { ...item };
      }
    });
  
    // Convert the grouped items back to an array
    return Object.values(groupedItems);
  };


  const groupedItems =
  quotationData?.quotation_type === 'General'
    ? groupItemsById(quotationData.items || [])
    : quotationData?.items || [];


  return (
    <div className="flex-1 bg-gray-50 min-h-screen">
      {renderHeader()}
      <div className="bg-[#F5F7FA] flex-1 p-4 pt-2 pb-12 overflow-y-auto">
        <div className="bg-white rounded-lg shadow-md">
          <div className="p-4">
           {groupedItems.map((item) => (
                <div
                  key={item?._id}
                  className="mx-0 mt-4 lg:mx-8 bg-white rounded-lg shadow-md overflow-hidden border border-gray-200"
                >
                  <div className="p-2 border-b border-gray-100">
                    <div className="flex justify-between items-center">
                      {/* For Group quotations, show area name */}
                      {quotationData.quotation_type === 'Group' ? (
      <span className="text-lg font-semibold text-[#EA011F]">
        {item?.area_types?.area_name}
      </span>
    ) : null}
  {quotationData.quotation_type === 'Group' ? (
                        <span className="text-lg font-semibold text-[#EA011F]">
                          {item?.area_types?.area_name}
                        </span>
                      ) : (
                        <span className="text-lg font-semibold text-[#EA011F]">
                          {item.item_name || "Item Details"}
                        </span>
                      )}
  
                      {/* For Group quotations, show area */}
                      {quotationData.quotation_type === 'Group' && (
                        <span className="text-sm font-medium text-gray-600">
                          <button
                            onClick={() => {
                              setSelectedDetails(item.quantity_breakup);
                              setIsDetailsModalVisible(true);
                            }}
                            className="flex items-center gap-1 text-sm font-medium text-gray-600 hover:text-[#EA011F] transition-colors group"
                            title="Click to view area details"
                          >
                            <span>
                              {parseFloat(item?.area_types?.area).toFixed(2)} sq.ft
                            </span>
                            <svg
                              className="w-4 h-4 group-hover:translate-x-1 transition-transform"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </button>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="p-2">
      <div className="flex justify-between items-center mb-2">
        <span className="text-base font-medium text-gray-800">
          {item.item_name}
        </span>
        <div className="flex items-center gap-6">
          {/* Change button for both General and Group quotations */}
          <button
            onClick={() =>
              handleChangeProduct(
                quotationData.quotation_type === 'Group'
                  ? item?.area_types?.area_name
                  : item.item_name,
                item.item_id
              )
            }
            className="px-2 py-0 border border-[#EA011F] rounded-full"
          >
            <span className="text-[#EA011F] text-sm font-regular">Change</span>
          </button>
        </div>
      </div>
      <div className="grid grid-cols-3 items-center">
        <p className="text-sm text-gray-500">
          {quotationData.quotation_type === 'Group'
            ? `₹${item.price_per_sqft}/sq.ft`
            : `₹${item.selling_price}/${item.UOM}`}
        </p>
        {quotationData.quotation_type === 'Group' && (
          <p className="text-sm font-medium text-gray-500 text-center">
            {parseFloat(item?.area_types?.area).toFixed(2)} sq.ft
          </p>
        )}
      </div>

      <div className="flex justify-between bg-gray-100 items-center">
        <p className="text-sm text-gray-500">
          ₹{item.selling_price}/{item.UOM}
        </p>
        <p className="text-sm text-red-500">
          <span className="font-bold">{item.quantity}</span> {item.UOM}
        </p>
        <p className="font-bold text-md text-green-700">
          ₹{item.total.toLocaleString("en-IN")}
        </p>
      </div>
      <div className="flex justify-end mt-1">
        <div className="text-right">
          <p className="text-xs text-gray-500">
            {item.tax_rate}% {item.tax_type}
          </p>
          <p className="text-xs text-gray-500">
            {quotationData?.tax_prefrence}
          </p>
        </div>
      </div>
  
                    {/* View designs button - only for Group quotations */}
                    {quotationData.quotation_type === 'Group' && (
                      <div className="flex items-center justify-between mt-3 pt-2 border-t border-gray-200">
                        <button
                          onClick={() => handleViewDesigns(item)}
                          className="group relative flex items-center gap-1 px-4 py-1.5 bg-gradient-to-r from-red-50 to-white rounded-lg border border-red-100 hover:border-[#EA011F] transition-all duration-300"
                        >
                          <div className="w-5 h-5 rounded-full bg-white shadow-sm flex items-center justify-center">
                            <FontAwesomeIcon
                              icon={faImages}
                              className="text-[#EA011F] text-xs group-hover:scale-110 transition-transform"
                            />
                          </div>
                          <span className="text-sm font-medium text-gray-700 group-hover:text-[#EA011F] transition-colors">
                            View Designs
                          </span>
                        </button>
  
                        {item.selected_design &&
                          item.selected_design.design_image && (
                            <div className="inline-block text-center">
                              <div className="relative w-10 h-10 mb-1">
                                <div className="w-full h-full rounded-md overflow-hidden border border-red-200 shadow-sm">
                                  <img
                                    src={`${imageUrl}${item.selected_design.design_image}`}
                                    alt="Selected design"
                                    className="w-full h-full object-cover"
                                    onClick={() => {
                                      setSelectedImageUrl(
                                        `${imageUrl}${item.selected_design.design_image}`
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="text-xs font-medium text-gray-700 max-w-[70px] truncate">
                                {item.selected_design.design_name ||
                                  "Selected Design"}
                              </div>
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                </div>
              )
              )}        
          </div>
        </div>
      </div>
  
      <div className="sticky bottom-0 left-0 right-0 p-3 shadow-lg bg-gray-100">
        <div className="max-w-7xl mx-auto flex gap-4">
          <button
            onClick={() => {
              const hasModifiedProducts = quotationData?.items?.some(
                (item) => item.isModified
              );
  
              if (hasModifiedProducts) {
                setIsSavingQuote(true);
                handleSaveQuotation();
              } else {
                setShowNoChangesModal(true);
              }
            }}
            className="w-full md:w-1/8 bg-red-500 py-2 px-4 rounded-lg text-white font-regular text-md hover:bg-red-700 whitespace-nowrap"
          >
            Save Changes
          </button>
        </div>
      </div>
    
    
  


    {showNoChangesModal && (
  <div className="fixed inset-0 flex items-center justify-center z-50">
    <div className="bg-black bg-opacity-50 absolute inset-0" onClick={() => setShowNoChangesModal(false)} />
    <div className="bg-white rounded-lg p-6 w-11/12 max-w-md relative z-10">
      <h2 className="text-xl font-bold text-[#EA011F] mb-4 text-center">No Changes Found</h2>
      <p className="text-gray-700 text-center mb-6">There are no modifications to save.</p>
      <button
        className="w-full bg-[#EA011F] text-white py-2 rounded-lg font-semibold"
        onClick={() => setShowNoChangesModal(false)}
      >
        Close
      </button>
    </div>
  </div>
)}

    {isDetailsModalVisible && (
  <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
    <div className="bg-white p-6 rounded-lg w-11/12 max-w-md relative">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-[#EA011F]">Area Details</h2>
        <button 
          onClick={() => setIsDetailsModalVisible(false)}
          className="text-gray-500 hover:text-gray-700"
        >
          <FontAwesomeIcon icon={faTimes} className="text-xl" />
        </button>
      </div>
      
      <div className="max-h-[60vh] overflow-y-auto">
        {Object.entries(selectedDetails || {}).map(([roomName, details]) => (
          <div key={roomName} className="bg-gray-50 p-3 rounded-lg mb-3">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">{roomName}</h3>
            <div className="flex justify-between">
              <span className="text-gray-600">Area: {details.area.toFixed(2)} sq.ft</span>
              <span className="text-gray-600 font-medium">Boxes: {details.boxes}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)}

{selectedImageUrl && (
  <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70">
    <button 
      onClick={() => {
        setSelectedImageUrl(null);
        setIsDesignsModalVisible(true); 
      }}
      className="absolute top-4 right-4 text-white hover:text-red-500 transition-colors"
    >
      <FontAwesomeIcon icon={faTimes} size="2x" />
    </button>
    <img 
      src={selectedImageUrl}
      alt="Full size preview" 
      className="max-w-[90vw] max-h-[70vh] object-contain"
    />
  </div>
)}

{showDesignConfirmation && (
  <div className="fixed inset-0 z-[70] flex items-center justify-center">
    <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
    <div className="relative transform transition-all duration-300 ease-in-out scale-100">
      <div className="bg-white rounded-xl shadow-xl p-6 w-[100%] max-w-md mx-auto" style={{ minHeight: '200px' }}>
        <div className="flex flex-col items-center">
          {/* Success Icon with reduced size */}
          <div className="relative mb-4">
            <div className="absolute inset-0 bg-green-100 rounded-full animate-ping opacity-20"></div>
            <div className="relative w-14 h-14 bg-gradient-to-br from-green-400 to-green-500 rounded-full flex items-center justify-center">
              <FontAwesomeIcon icon={faCheck} className="text-white text-xl" />
            </div>
          </div>

          {/* Content with adjusted typography */}
          <div className="text-center space-y-2 ">
            <h3 className="text-lg font-semibold text-gray-800">
              Design Updated Successfully!
            </h3>
            <p className="text-sm text-gray-600">
              Thanks for choosing a new design for
              {/* <span className="block mt-1 font-medium text-[#EA011F]">{selectedRoomCategory}</span> */}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)}

{isDesignsModalVisible && (
  <ProductDesignsModal
    products={selectedProduct?.products || []} 
    onClose={() => setIsDesignsModalVisible(false)} 
    handleProductSelection={handleDesignSelection} 
    selectedDesign={selectedDesign} 
    setSelectedDesign={setSelectedDesign} 
    setSelectedImageUrl={setSelectedImageUrl} 
    imageUrl={imageUrl} 
    selectedCategory={selectedCategory} 
    currentSelectedProduct={selectedProduct} 
    categories={categories} 
  />
)}

{isProductModalVisible && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div className="bg-white w-full max-w-2xl rounded-lg shadow-lg mx-4">
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-red-500">Select Product Group</h2>
          <button 
            onClick={() => setIsProductModalVisible(false)}
            className="text-gray-600 hover:text-gray-800"
          >
            <FontAwesomeIcon icon={faTimes} className="text-2xl" />
          </button>
        </div>

        <div className="max-h-[70vh] overflow-y-auto">
          {availableProducts.map(product => (
            <button
              key={product._id}
              className="flex items-center p-4 border-b border-gray-200 w-full hover:bg-gray-50"
              onClick={() => handleProductSelection(product)}
            >
              <div className="mr-3">
                <div className="h-5 w-5 rounded-full border-2 border-[#EA011F] flex justify-center items-center">
                  {selectedProductId === product._id && (
                    <div className="h-3 w-3 rounded-full bg-[#EA011F]" />
                  )}
                </div>
              </div>
              <img
                src={`${imageUrl}${product.product_group_image}`}
                alt={product.product_group_name}
                className="w-14 h-14 rounded-lg object-cover"
              />
              <div className="flex-1 ml-4">
               
               <p className="text-lg font-bold text-gray-800 text-left">{product.product_group_name}</p>
               ₹{product.price_per_sqft}/sq.ft
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  </div>
)}
</div>
);
};
export default QuotationDetails;